import { authApi } from './auth';
import { sharedApi } from './shared';
import { companyApi } from './company';
import { merchantApi } from './merchant';
import { riderApi } from './rider';
import { adminApi } from './admin';
import { shopApi } from './shop';

export const api = { ...authApi, ...sharedApi, ...companyApi, ...merchantApi, ...riderApi, ...adminApi, ...shopApi };

export { authApi, sharedApi, companyApi, merchantApi, riderApi, adminApi, shopApi };
export { request, buildQueryString, API_BASE } from './request';